import React from 'react'

const Quizes = () => {
    return <h1>Welcome to the Quizes Page</h1>;
    }
export default Quizes;
